import { AlertTriangle, Droplets, Skull } from "lucide-react";

export const ProblemSection = () => (
  <section className="py-12 md:py-16 bg-secondary/40">
    <div className="max-w-3xl mx-auto px-4 text-center space-y-6">
      <div className="animate-[fadeInUp_0.4s_ease-out_both]">
        <p className="text-lg md:text-xl text-foreground leading-relaxed">
          Vous touchez la terre, elle semble sèche. Vous arrosez.{" "}
          <strong className="text-destructive">Mais en profondeur, vos plantes étouffent.</strong>
        </p>
      </div>

      <div className="inline-flex items-center gap-3 bg-destructive/10 border border-destructive/20 rounded-xl px-6 py-4 animate-[fadeIn_0.4s_ease-out_0.15s_both]">
        <AlertTriangle className="w-6 h-6 text-destructive flex-shrink-0" />
        <span className="text-base md:text-lg font-bold text-destructive">
          67% des plantes meurent d'un excès d'eau.
        </span>
      </div>

      <div className="grid grid-cols-3 gap-4 pt-4 max-w-md mx-auto">
        {[
          { icon: Droplets, label: "Sur-arrosage" },
          { icon: Skull, label: "Racines noyées" },
          { icon: AlertTriangle, label: "Feuilles jaunes" },
        ].map(({ icon: Icon, label }) => (
          <div
            key={label}
            className="flex flex-col items-center gap-2 text-muted-foreground"
          >
            <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
              <Icon className="w-5 h-5 text-destructive" />
            </div>
            <span className="text-xs font-medium">{label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
